import { useGetComentariosColaboradorQuery } from "src/gql/schema"
import { MantenimientoComentario } from "../MantenimientosDetail.type"

interface UseComentariosMantenimientoProps {
    colaboradorTareaId?: string
    enabled: boolean
}

// Los comentarios del mantenimiento viven en la tarea del colaborador, igual que en el detalle
// de la habitación en mantenimiento
const useComentariosMantenimiento = ({ colaboradorTareaId, enabled }: UseComentariosMantenimientoProps) => {
    const { data, loading } = useGetComentariosColaboradorQuery({
        variables: { colaborador_tarea_id: String(colaboradorTareaId) },
        skip: !enabled || !colaboradorTareaId,
    })

    const comentarios: MantenimientoComentario[] = (data?.colaborador_tarea?.comentarios || []).map(
        (comentario, index) => ({
            id: `${index}`,
            fecha: comentario.fecha ? String(comentario.fecha) : null,
            comentario: comentario.comentario,
        })
    )

    return { comentarios, loading }
}

export default useComentariosMantenimiento
